export { ProductImageGalleryZoomPresenter } from './ImageGalleryZoomPresenter'
